import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import "./MamahoodMarketingHeader.css";

const BASE = "/twentytwentysix";

function navLinkClassName({ isActive }) {
  return `mh-nav__link${isActive ? " mh-nav__link--active" : ""}`;
}

/**
 * Mamahood marketing header (mh-* styles) shared across twentytwentysix routes.
 * Active nav state comes from NavLink (react-router-dom v6).
 *
 * Top bar height: CSS vars on `.mh-header__top` — use `height` / `headerPaddingY` props,
 * or `headerTopStyle` / inline `style` on the layout wrapper for `--mh-header-*` vars only.
 */
export function MamahoodMarketingHeader({
  height,
  headerMinHeight,
  headerPaddingY,
  headerTopStyle,
  className,
  ...rest
} = {}) {
  const minH = headerMinHeight ?? height;
  const topStyle = {
    ...(minH != null && minH !== "" && { "--mh-header-height": minH }),
    ...(headerPaddingY != null && headerPaddingY !== "" && {
      "--mh-header-padding-y": headerPaddingY,
    }),
    ...headerTopStyle,
  };
  const hasTopStyle = Object.keys(topStyle).length > 0;
  const headerClass = ["mh-header", className].filter(Boolean).join(" ");

  return (
    <header className={headerClass} {...rest}>
      <div className="mh-header__top" style={hasTopStyle ? topStyle : undefined}>
        <Link to={BASE} className="mh-brand">
          <div className="mh-brand__mark">M</div>
          <div className="mh-brand__name">THE MAMAHOOD</div>
        </Link>

        <div className="mh-header__nav-row">
          <div className="mh-socials">
            <a href="#" className="mh-socials__icon" aria-label="Facebook">
              <FaFacebookF aria-hidden />
            </a>
            <a href="#" className="mh-socials__icon" aria-label="Instagram">
              <FaInstagram aria-hidden />
            </a>
            <a href="#" className="mh-socials__icon" aria-label="LinkedIn">
              <FaLinkedinIn aria-hidden />
            </a>
          </div>

          <nav className="mh-nav" aria-label="Primary">
            <NavLink to={BASE} end className={navLinkClassName}>
              Home
            </NavLink>
            <NavLink to={`${BASE}/resources`} className={navLinkClassName}>
              Resources
            </NavLink>
            <NavLink to={`${BASE}/podcasts`} className={navLinkClassName}>
              Podcasts
            </NavLink>
            <NavLink to={`${BASE}/events`} className={navLinkClassName}>
              Events
            </NavLink>
            <NavLink to={`${BASE}/membership`} className={navLinkClassName}>
              Membership
            </NavLink>
            <NavLink to={`${BASE}/collective`} end className={navLinkClassName}>
              Collective
            </NavLink>
          </nav>

          <div className="mh-header__actions">
            <Link to={`${BASE}/join`} className="mh-pill mh-pill--small">
              Join
            </Link>
            <Link to={`${BASE}/login`} className="mh-avatar" aria-label="Go to login">
              👤
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

export default MamahoodMarketingHeader;
